import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, Search, SearchMenuFields } from '@gn-audio/jss-components';

type SearchProps = ComponentProps & {
  fields: SearchMenuFields;
};

export default withDatasourceCheck()<SearchProps>(Search);
